export { DialogPublicarTransito } from './components/DialogPublicarTransito';
export { CertificadoAcessosSentencaDocumento } from './components/documentos/certificado-acessos-sentenca/CertificadoAcessosSentencaDocumento';
export { CertificadoAcessosSentencaView } from './components/documentos/certificado-acessos-sentenca/CertificadoAcessosSentencaView';
export { CertificadoAcessosSentencaContainer } from './components/documentos/CertificadoAcessosSentencaContainer';
export { IntimacaoSentencaContainer } from './components/documentos/IntimacaoSentencaContainer';
export { SentencaArbitralContainer } from './components/documentos/SentencaArbitralContainer';
export { FaixaEstadoPosSentenca } from './components/FaixaEstadoPosSentenca';
export { FiltroFilaPrazos } from './components/FiltroFilaPrazos';
export { GrupoEncerramentoCertificados } from './components/GrupoEncerramentoCertificados';
// TODO: remover — sem consumidor desde a retirada do mock de `MenuAcoesProcesso` (PR #925).
// Vale também para `MotivoBloqueioTransito` em `types/encerramento.types`. Preservados porque a
// frente de encerramento segue ativa; apagar no sweep dos protótipos se não forem reusados.
export { ItemAcaoBloqueada } from './components/ItemAcaoBloqueada';
export { useCertificadoAcessosSentenca } from './hooks/useCertificadoAcessosSentenca';
export { MOCK_INTIMACAO_SENTENCA } from './mocks/encerramento.mock';
export type * from './types/certificadoAcessosSentenca.types';
export type * from './types/encerramento.types';
export type * from './types/sentencaArbitral.types';
export { certidoesDoEncerramento } from './utils/certidoesDoEncerramento';
export {
  estadoPosSentencaDoProcesso,
  podeAfirmarEstadoPosSentenca,
  sentencaFoiProferida,
} from './utils/estadoPosSentenca';
export {
  ehFilaEsclarecimento,
  FILA_ESCLARECIMENTO,
  FILA_ESCLARECIMENTO_LABEL,
} from './utils/filaEsclarecimento';
export { rotaProcessoPorOrigem } from './utils/rotaProcessoPorOrigem';
